<template>
  <ubi-panel style="background-color: #EBF3F2;">
              <ubi-search-container
                  :filters="filters"
                  v-on:resetfilter="doFilter('resetfilter')"
                  @filter="doFilter($event)"
                  :defaultFilter="this.filter.preset"
                  :more-opened="filter.advanced"
                  @update:more-opened="advanced => setFilter({ advanced })"
              >

                <!-- Search field -->
                <el-row :gutter="20">
                  <el-col :lg="10" v-if="nbStocks > 1">
                    <el-form-item :label="$t('general.filters.stockSelection')">
                      <el-select
                              v-model="filter.stock"
                              :placeholder="$t('general.filters.stockSelectionPlaceholder')"
                      >
                        <el-option
                                v-for="stock in stocks"
                                :key="stock.id"
                                :label="upperCase(stock.nom)"
                                :value="stock.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="14">
                    <el-form-item no-help :label="$t('general.filters.openSearch')">
                      <el-input
                              type="text"
                              v-model="filter.search"
                              @input="setSearch"
                              :placeholder="$t('general.filters.openSearchPlaceholder')"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" style="padding-left: 10px; padding-right: 10px;padding-top:10px;">
                    <el-form-item :label="$t('general.filters.brand')">
                      <el-select
                              v-model="filter.marque"
                              :placeholder="$t('general.filters.brandPlaceholder')"
                              clearable
                              filterable
                              @change="$emit('charger-liste-modele', filter.marque)"
                      >
                        <el-option
                                style="text-transform:capitalize"
                                v-for="marqueChoice in marqueVehicule"
                                :key="marqueChoice"
                                :label="marqueChoice"
                                :value="marqueChoice"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" style="padding-left: 10px; padding-right: 10px;padding-top:10px;">
                    <el-form-item :label="$t('general.filters.model')">
                      <el-select
                              v-model="filter.modele"
                              :placeholder="$t('general.filters.modelPlaceholder')"
                              clearable
                              filterable
                      >
                        <el-option
                                style="text-transform:capitalize"
                                v-for="modeleChoice in modeleVehicule"
                                :key="modeleChoice"
                                :label="modeleChoice"
                                :value="modeleChoice"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <template v-slot:more>
                  <el-row :gutter="20">
                    <el-col :span="6">
                      <el-form-item :label="$t('general.filters.dateCreation')">
                        <el-date-picker
                                type="daterange"
                                :value="filter.dateCreationGt || filter.dateCreationLt? [
                                                  filter.dateCreationGt || undefined,
                                                  filter.dateCreationLt || undefined
                                                ]:null"
                                :start-placeholder="$t('general.filters.dateCreationStart')"
                                :end-placeholder="$t('general.filters.dateCreationEnd')"
                                @input="
                                                  dates =>
                                                    addFilter({
                                                      dateCreationGt: dates ? dates[0] : null,
                                                      dateCreationLt: dates ? dates[1] : null
                                                    })
                                                "
                                :picker-options="pickerOptions"
                        ></el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <!-- Price minimum field -->
                      <el-form-item no-help :label="$t('general.filters.vehicleYear')">
                        <el-input
                                min="0"
                                type="number"
                                v-model="filter.millesime"
                                @input="millesime => addFilter({ millesime })"
                                :placeholder="$t('')"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <!-- Price minimum field -->
                      <el-form-item no-help :label="$t('general.filters.priceMin')">
                        <el-input
                                step="100"
                                min="0"
                                type="number"
                                v-model="filter.priceGt"
                                @input="priceGt => addFilter({ priceGt })"
                                :placeholder="$t('')"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <!-- Price maximum field -->
                      <el-form-item no-help :label="$t('general.filters.priceMax')">
                        <el-input
                                step="100"
                                min="0"
                                type="number"
                                v-model="filter.priceLt"
                                @input="priceLt => addFilter({ priceLt })"
                                :placeholder="$t('')"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :lg="8" v-if="isMainAccount || isSubAdmin">
                      <el-form-item :label="$t('posts.edit.user')">
                        <el-select
                                v-model="filter.user"
                                clearable
                                filterable
                                reserve-keyword
                        >
                          <el-option
                                  style="text-transform:capitalize"
                                  v-for="filterUser in users"
                                  :key="filterUser.id"
                                  :value="filterUser.id"
                                  :label="filterUser.fullname + ' - ' + filterUser.username"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :lg="8">
                      <el-form-item :label="$t('users.contact')">
                        <el-select
                            v-model="filter.contact"
                            clearable
                            filterable
                            reserve-keyword
                        >
                          <el-option
                              style="text-transform:capitalize"
                              v-for="filterContact in contacts"
                              v-if="filterContact.fullname"
                              :key="filterContact.id"
                              :value="filterContact.email"
                              :label="filterContact.fullname"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :lg="12">
                      <el-form-item>
                        <el-radio-group
                            :value="filter.annoncesDiffusees"
                            @input="annoncesDiffusees => addFilter({ annoncesDiffusees })">
                          <el-radio value="O" label="O">{{ $t("general.filters.diffusedAds") }}</el-radio>
                          <el-radio value="N" label="N">{{ $t("general.filters.noDiffusedAds") }}</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </template>
              </ubi-search-container>
  </ubi-panel>
</template>

<script>

import { mapGetters, mapMutations, mapState } from 'vuex'
import ElButton from '../../../../components/Button'
import PostFilterObjectType from '../../components/PostFilterObjectType'
import { getUsers } from '../../../../services/users'

export default {
  name: 'SearchImmoDefault',
  props: ['marqueVehicule', 'modeleVehicule'],
  components: {
    PostFilterObjectType,
    ElButton
  },
  data () {
    return {
      users: '',
      contacts: '',
      search: '',
      filters: [
        { value: 'allAds', label: this.$t('general.filters.allAds') },
        { value: 'enable', label: this.$t('general.filters.activeAds') },
        { value: 'disabled', label: this.$t('general.filters.inactiveOrDraftAds') },
        { value: 'withoutPictures', label: this.$t('general.filters.withoutPictures') },
        { value: 'modeles', label: this.$t('general.filters.modelAds') }
      ]
    }
  },
  computed: {
    ...mapState('postsVo', ['filter', 'results']),
    ...mapGetters(['hasMultiAccounts', 'isMainAccount', 'isSubAdmin', 'isSubUser', 'getOfferTypes', 'getPickerOptionsShortcuts']),
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    },
    user () {
      return this.$store.getters.getUser
    },
    userJob () {
      return this.sitimmoUser.metier
    },
    possedeContactManager () {
      return this.sitimmoUser.possede_contact_manager
    },
    saisit_en_ligne () {
      return (this.sitimmoUser.saisit_annonces_en_ligne === true || this.sitimmoUser.saisit_en_ligne_et_flux === true)
    },
    packExpert () {
      return this.sitimmoUser.packDiffusion === 'pack_expert'
    },
    garantiePublication () {
      return this.sitimmoUser.garantiePublication === 'true'
    },
    nbStocks () {
      return this.sitimmoUser.stocks.length
    },
    stocks () {
      return this.sitimmoUser.stocks
    },
    userFilter () {
      return this.filter.user
    },
    pickerOptions () {
      return {
        shortcuts: this.getPickerOptionsShortcuts
      }
    }
  },
  methods: {
    ...mapMutations('postsVo', [
      'setPage',
      'setLimit',
      'setSort',
      'setSearch',
      'setFilter',
      'addFilter',
      'setOffset',
      'setLimit',
      'setResults',
      'getPresetFilters',
      'resetFilter',
      'setObjectType'
    ]),
    upperCase (string) {
      if (!string) return ''
      return string.charAt(0).toUpperCase() + string.substr(1)
    },
    async doFilter (type) {
      this.filter.preset = type
      switch (type) {
        case 'resetfilter':
          this.resetFilter()
          this.filter.annoncesActivees = true
          break
        case 'archived':
          this.setFilter({
          })
          break
        case 'allAds':
          this.filter.annoncesActivees = null
          this.filter.annoncesDesactivees = null
          this.filter.annoncesModeles = null
          this.filter.withoutPictures = null
          this.setFilter(this.filter)
          break
        case 'enable':
          this.filter.annoncesActivees = true
          this.filter.annoncesDesactivees = null
          this.filter.annoncesModeles = null
          this.filter.withoutPictures = null
          this.setFilter(this.filter)
          break
        case 'disabled':
          this.filter.annoncesDesactivees = true
          this.filter.annoncesActivees = null
          this.filter.annoncesModeles = null
          this.filter.withoutPictures = null
          this.setFilter(this.filter)
          break
        case 'modeles':
          this.filter.annoncesActivees = null
          this.filter.annoncesDesactivees = null
          this.filter.annoncesModeles = true
          this.filter.withoutPictures = null
          this.setFilter(this.filter)
          break
        case 'withoutPictures':
          this.filter.annoncesActivees = null
          this.filter.annoncesDesactivees = null
          this.filter.annoncesModeles = null
          this.filter.withoutPictures = true
          this.setFilter(this.filter)
          break
        case 'resetFromSearch':
          this.filter.annoncesActivees = true
          this.filter.search = ''
          this.filter.typeObjets = null
          this.filter.annoncesDesactivees = null
          this.filter.annoncesSupprimees = null
          this.filter.annoncesModeles = null
          this.filter.withoutPictures = null
          this.filter.annoncesVendues = null
          this.filter.dateCreationGt = null
          this.filter.dateCreationLt = null
          this.filter.surfaceGt = null
          this.filter.surfaceLt = null
          this.filter.objectTypes = []
          this.filter.offerTypes = null
          this.filter.mandates = null
          this.filter.priceLt = null
          this.filter.priceGt = 0
      }
      this.$store.dispatch('postsVo/loadPosts')
      if (type == 'resetFromSearch') {
        type = 'allAds'
      }
    }
  },
  async beforeMount () {
    if (this.hasMultiAccounts) {
      this.users = (await getUsers({ active: true, pagination: false, roles: '!ROLE_CONTACT' })).list
    }
    const contacts = await getUsers()
    if (contacts) {
      this.contacts = contacts.list
    }
    if (this.sitimmoUser.saisit_annonces_en_ligne === false) {
      this.filters.pop()
    }
  }
}
</script>

<style>
.listContacts { margin-left: -33.3% }
</style>
